import { useParams } from "react-router-dom";

import { useUser } from "@/context/user-context";

export const useRequestLogsWorkspaceId = (): number => {
  const { workspaceId: workspaceIdParam } = useParams();
  const userWorkspaceId = useUser()?.activeWorkspaceId;
  return (userWorkspaceId ?? (workspaceIdParam ? Number(workspaceIdParam) : 0)) || 0;
};
